import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Socials from './Socials';
import CorpLinks from './CorpLinks';
import BrandLogo from './BrandLogo';
import GalleryLogo from './GalleryLogo';
import { SITE_HOST } from '../../consts';

export class Footer extends Component {
  render() {
    const { isMobile } = this.props;
    const renderedSocials = <Socials parent="Footer" />;
    // const FooterSubscribe = <Link className="footer-subscribe" to={{ type: 'SUBSCRIBE' }}>Subscribe</Link>;
    const FooterSubscribe = <a className="footer-subscribe" href={`${SITE_HOST}/subscribe`}>Subscribe</a>;

    return (
      <div className="footer" ref={node => this.footer = node}>
        {isMobile
          && <Fragment>
            <Link
              className="footer-contributor-link"
              to={{ type: 'CONTRIBUTE' }}>
            </Link>
            {renderedSocials}
            <CorpLinks isMobile={isMobile} />
            {FooterSubscribe}
            <GalleryLogo />
          </Fragment>
        }

        {!isMobile
          && <div className="footer-contents">
            <div className="footer-content">
              <BrandLogo footer={true}/>
            </div>

            <div className="footer-content">
              <CorpLinks isMobile={isMobile} />
            </div>

            <div className="footer-content">
              <h5 className="footer-content-hed">Follow Us</h5>
              {renderedSocials}
              {FooterSubscribe}
              <GalleryLogo />
            </div>
          </div>
        }

        <div className="footer-copyright">&copy;2019 PureWow. All rights reserved.</div>
      </div>
    );
  }
}

const mapStateToProps = ({ isMobile }) => ({ isMobile });

const FooterContainer = connect(mapStateToProps)(Footer);

export default FooterContainer;
